import { createBookingSettingsState } from "@/controllers/bookingSettingsState";
import bookingSettingsLifecycle from "@/controllers/bookingSettingsLifecycle";
import bookingSettingsDataMethods from "@/controllers/bookingSettingsDataMethods";
import bookingSettingsSaveMethods from "@/controllers/bookingSettingsSaveMethods";
import bookingSettingsHolidayMethods from "@/controllers/bookingSettingsHolidayMethods";

export default {
  data() {
    return createBookingSettingsState();
  },
  ...bookingSettingsLifecycle,
  methods: {
    ...bookingSettingsDataMethods,
    ...bookingSettingsSaveMethods,
    ...bookingSettingsHolidayMethods,
  },
};
